'use strict';

const RpcEngine = require('json-rpc-engine');
const { Web3Provider } = require("@ethersproject/providers")
const providerFromEngine = require('eth-json-rpc-middleware/providerFromEngine');
const providerAsMiddleware = require('eth-json-rpc-middleware/providerAsMiddleware');

const baseProviderProto = Object.getPrototypeOf(providerFromEngine(new RpcEngine()));

class BaseProvider {
  constructor(provider) { return makeBaseProvider(provider); }
  asEthers() {
    if (!this._ethers) this._ethers = new Web3Provider(this);
    return this._ethers;
  }
  asMiddleware() {
    return Object.assign(providerAsMiddleware(this), {
      _decorated: extractDecoratedProps(this)
    });
  }
}

const convertToBaseProvider = (provider) => Object.setPrototypeOf(provider, BaseProvider.prototype);

const lodash = require('lodash');

const extractDecoratedProps = (o) => {
  return lodash.difference(Object.keys(o), [
   '_events',
	    '_eventsCount',
	    '_maxListeners',
	    'sendAsync',
	    'send',
	    '_ethers'
  ]).reduce((r, v) => {
	  r[v] = o[v];
	  return r;
  }, {});
};

class PolymarketProviderEngine extends RpcEngine {
  constructor() {
    super();
    this._decorated = {};
  }
  push(middleware) {
    Object.assign(this._decorated, middleware._decorated || {});
    return super.push(middleware);
  }
  asProvider() {
    return Object.assign(convertToBaseProvider(providerFromEngine(this)), this._decorated);
  }
}

Object.setPrototypeOf(BaseProvider.prototype, baseProviderProto);

const makeBaseProvider = (provider) => {
  const engine = new PolymarketProviderEngine();
  const send = provider.send || provider.sendAsync;
  engine.push((req, res, next, end) => {
    send.call(provider, req, (err, result) => {
      Object.assign(res, result);
      end(err);
    });
  });
  return Object.assign(engine.asProvider(), {
    enable: provider.enable && provider.enable.bind(provider),
    baseProvider: provider.baseProvider
  });
};

module.exports = {
  makeBaseProvider,
  makeEngine: () => new PolymarketProviderEngine(),
  PolymarketProviderEngine,
  BaseProvider,
  convertToBaseProvider
};
